import * as React from 'react'
import styled from 'styled-components'
import { Content } from '../atoms/Content/index'
import { Layout } from '../atoms/Layout'
import { Nav } from '../atoms/Nav'
import { P } from '../atoms/P'
import { PainRatingContainer } from '../organisms/PainRating/PainRatingContainer'
import { media } from '../utils/media'

export const PainRatingPage = () => (
  <Layout>
    <Nav.Bar>
      <Nav.HomeButtonWeb />
    </Nav.Bar>
    <Content style={{ textAlign: 'center' }}>
      <H1>Pain Rating</H1>
      <P>
        Please ask your child to point to the face that matches how much pain they have and tick the appropriate box.
      </P>
      <PainRatingContainer />
    </Content>
  </Layout>
)

const H1 = styled.h1`
  margin-top: 90px;
  font-family: Nunito;
  font-size: 24px;
  font-weight: 900;
  color: #12385b;

  ${media.tablet`
    font-size: 54px;
  `}
`



// WEBPACK FOOTER //
// ./src/pages/PainRatingPage.tsx